import { render, staticRenderFns } from "./alogin.vue?vue&type=template&id=1bc12a48&scoped=true&"
import script from "./alogin.vue?vue&type=script&lang=js&"
export * from "./alogin.vue?vue&type=script&lang=js&"
import style0 from "./alogin.vue?vue&type=style&index=0&id=1bc12a48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc12a48",
  null
  
)

export default component.exports